import { DropdownData, InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { Form, FormField, FormSection, FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {DashboardService} from '../../../../../service/events/dashboard.service';
import {BaseForm} from '../../../../base-form';
import {VisitasApiService} from '../../../../../service/api/visitas-api.service';
import {FincasApiService} from '../../../../../service/api/fincas-api.service';
import {FormCommonApiService} from '../../../../../service/api/formcommon-api.service';
import {build, list, pool} from '../../../../../common/classes/request-builder';
import { environment } from '../../../../../../environments/environment';

import type { OnInit } from '@angular/core';
import { ParcelasModel } from 'src/app/models/form-common/parcelas.model';
import { TrasiegoModel } from 'src/app/models/visitas/trasiego.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import type {
    ReactiveFormChangedField,
    ReactiveFormValue,
} from 'src/app/common/components/reactive-form-builder/interfaces/reactive-form-change.interface';

@Component({
    selector: 'app-visitas-trasiego-form',
    standalone: false,
    templateUrl: './visitas-trasiego-form.component.html',
    styleUrls: ['./visitas-trasiego-form.component.scss']
})
export class VisitasTrasiegoFormComponent extends BaseForm<TrasiegoModel> implements OnInit {


    public override model: TrasiegoModel = {semana: 0};
    public reactiveForm!: { formType: FormType; model: Partial<TrasiegoModel>; formFields: Form<TrasiegoModel> };
    public showVisitasTrasiego10Plagas = environment.features.showVisitasTrasiento10Plagas;

    public fincas = list<FincasModel>(['...', null]);
    public parcelas = list(['...', null]);
    public semanas: DropdownData<number> = list(['...', null],
        1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
        37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54
    );
    public anos: DropdownData<number> = list(['...', null],
        2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030
    );
    public plagas = list(
        ['...', null],
        'Empoasca',
        'Mosca blanca',
        'Mosca común',
        'Mosquito',
        'Parasitoides',
        'Pulgón',
        'Scatella',
        'Sciara',
        'Stethorus',
        'Trips',
        'Otros'
    );
    public trampas = list(
        ['...', null],
        'T.S1',
        'T.S4',
        'T.SEMILLERO',
        'T.S5',
        'T.S7',
        'T.S8',
        'T.S10',
        'T.MICROS',
        'FC-T.S1',
        'FC-T.S2'
    );

    public formFields: FormField<any>[] = [
    {
        name: 'id_finca',
        field: 'id_finca',
        vinculatedFields: undefined,
        label: 'Agrupación',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.fincas, dropdownConfiguration: { valuePrimaryKey: 'id' }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: Boolean(true), isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: Boolean(true),        values: this.fincas,

        order: 1
    },
    {
        name: 'id_parcela',
        field: 'id_parcela',
        vinculatedFields: undefined,
        label: 'Subparcela',
        input: { type: InputType.DROPDOWN_SEARCH, isEditable: true, data: this.parcelas, dropdownConfiguration: { valuePrimaryKey: 'id', filter: (it: { value: ParcelasModel; }) => {
                const parcela = it.value;
                if (this.fincas.selected && parcela) {
                    return this.fincas.selected.id === parcela.id_finca;
                }
                return true;
            } }, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: Boolean(true), isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: Boolean(true),        values: this.parcelas,

        order: 2
    },
    {
        name: 'semana',
        field: 'semana',
        vinculatedFields: undefined,
        label: 'Semana',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.semanas, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.semanas,

        order: 3
    },
    {
        name: 'ano',
        field: 'ano',
        vinculatedFields: undefined,
        label: 'Año',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.anos, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.anos,

        order: 4
    },
    {
        name: 'trampa',
        field: 'trampa',
        vinculatedFields: undefined,
        label: 'Trampa',
        input: { type: InputType.DROPDOWN, isEditable: true, data: this.trampas, optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: this.trampas,

        order: 5
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 6
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 7
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 8
    },
    {
        name: 'plaga1',
        field: 'plaga1',
        vinculatedFields: undefined,
        label: 'Plaga #1',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.plagas)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: JSON.parse(JSON.stringify(this.plagas)),

        order: 9
    },
    {
        name: 'cantidad1',
        field: 'cantidad1',
        vinculatedFields: undefined,
        label: 'Cantidad #1',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 10
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 11
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 12
    },
    {
        name: 'plaga2',
        field: 'plaga2',
        vinculatedFields: undefined,
        label: 'Plaga #2',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.plagas)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: JSON.parse(JSON.stringify(this.plagas)),

        order: 13
    },
    {
        name: 'cantidad2',
        field: 'cantidad2',
        vinculatedFields: undefined,
        label: 'Cantidad #2',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 14
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 15
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 16
    },
    {
        name: 'plaga3',
        field: 'plaga3',
        vinculatedFields: undefined,
        label: 'Plaga #3',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.plagas)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: JSON.parse(JSON.stringify(this.plagas)),

        order: 17
    },
    {
        name: 'cantidad3',
        field: 'cantidad3',
        vinculatedFields: undefined,
        label: 'Cantidad #3',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 18
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 19
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 20
    },
    {
        name: 'plaga4',
        field: 'plaga4',
        vinculatedFields: undefined,
        label: 'Plaga #4',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.plagas)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: JSON.parse(JSON.stringify(this.plagas)),

        order: 21
    },
    {
        name: 'cantidad4',
        field: 'cantidad4',
        vinculatedFields: undefined,
        label: 'Cantidad #4',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 22
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 23
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 24
    },
    {
        name: 'plaga5',
        field: 'plaga5',
        vinculatedFields: undefined,
        label: 'Plaga #5',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.plagas)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: JSON.parse(JSON.stringify(this.plagas)),

        order: 25
    },
    {
        name: 'cantidad5',
        field: 'cantidad5',
        vinculatedFields: undefined,
        label: 'Cantidad #5',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 26
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 27
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 28
    },
    {
        name: 'plaga6',
        field: 'plaga6',
        vinculatedFields: undefined,
        label: 'Plaga #6',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.plagas)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,        values: JSON.parse(JSON.stringify(this.plagas)),

        order: 29
    },
    {
        name: 'cantidad6',
        field: 'cantidad6',
        vinculatedFields: undefined,
        label: 'Cantidad #6',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: true },
        required: false,
        order: 30
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 31
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 32
    },
    {
        name: 'plaga7',
        field: 'plaga7',
        vinculatedFields: undefined,
        label: 'Plaga #7',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.plagas)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: this.showVisitasTrasiego10Plagas,        values: JSON.parse(JSON.stringify(this.plagas)),

        order: 33
    },
    {
        name: 'cantidad7',
        field: 'cantidad7',
        vinculatedFields: undefined,
        label: 'Cantidad #7',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: this.showVisitasTrasiego10Plagas,
        order: 34
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 35
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 36
    },
    {
        name: 'plaga8',
        field: 'plaga8',
        vinculatedFields: undefined,
        label: 'Plaga #8',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.plagas)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: this.showVisitasTrasiego10Plagas,        values: JSON.parse(JSON.stringify(this.plagas)),

        order: 37
    },
    {
        name: 'cantidad8',
        field: 'cantidad8',
        vinculatedFields: undefined,
        label: 'Cantidad #8',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: this.showVisitasTrasiego10Plagas,
        order: 38
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 39
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 40
    },
    {
        name: 'plaga9',
        field: 'plaga9',
        vinculatedFields: undefined,
        label: 'Plaga #9',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.plagas)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: this.showVisitasTrasiego10Plagas,        values: JSON.parse(JSON.stringify(this.plagas)),

        order: 41
    },
    {
        name: 'cantidad9',
        field: 'cantidad9',
        vinculatedFields: undefined,
        label: 'Cantidad #9',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: this.showVisitasTrasiego10Plagas,
        order: 42
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 43
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 44
    },
    {
        name: 'plaga10',
        field: 'plaga10',
        vinculatedFields: undefined,
        label: 'Plaga #10',
        input: { type: InputType.DROPDOWN, isEditable: true, data: JSON.parse(JSON.stringify(this.plagas)), optionLabel: 'label', optionValue: 'value' },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: this.showVisitasTrasiego10Plagas,        values: JSON.parse(JSON.stringify(this.plagas)),

        order: 45
    },
    {
        name: 'cantidad10',
        field: 'cantidad10',
        vinculatedFields: undefined,
        label: 'Cantidad #10',
        input: { type: InputType.NUMERIC, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: this.showVisitasTrasiego10Plagas,
        order: 46
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 47
    },
    {
        name: '',
        field: '',
        vinculatedFields: undefined,
        label: '',
        input: { type: InputType.EMPTY, isEditable: true },
        width: 3,
        conditions: { isRememberedOnDuplicate: true, isRequired: false, isRetained: false, hasUndoEnabled: false, isVisible: Boolean(!this.showVisitasTrasiego10Plagas) },
        required: false,
        visible: !this.showVisitasTrasiego10Plagas,
        order: 48
    },
];



    private createReactiveForm(): void {
        const formType = Number(this.getType()) as FormType;
        this.reactiveForm = {
            formType,
            model: this.model,
            formFields: {
                name: 'visitas-trasiego',
                header: this.getType() === FormType.EDITION ? this.headerTitleWhenEdit : this.headerTitleWhenNew,
                type: formType,
                sections: this.getReactiveSections(),
                table: null,
                uploadButton: { isEnabled: Boolean(false), label: '' },
                signed: Boolean(false),
            },
        };
    }

    private getReactiveSections(): FormSection<TrasiegoModel>[] {
        return [
            { name: 'Datos de visita', fields: this.formFields, width: 12, isVisible: true, order: 1 },
        ];
    }

    public reactiveFormChanges(
        formModel: ReactiveFormValue<TrasiegoModel>,
        lastChangedFieldName: ReactiveFormChangedField<TrasiegoModel>,
    ): void {
        this.model = { ...this.model, ...formModel } as TrasiegoModel;
        (this.formChanges as (tag?: string) => void).call(this, String(lastChangedFieldName ?? ''));
        if (this.reactiveForm) {
            this.reactiveForm.model = this.model;
        }
    }

    constructor(
        public override route: ActivatedRoute,
        public override dashboard: DashboardService,
        public visitasApi: VisitasApiService,
        public fincasApi: FincasApiService,
        public formApi: FormCommonApiService,
        public override router: Router
    ) {
        super(
            route,
            router,
            dashboard,
            visitasApi.visitasTrasiego.PUT,
            visitasApi.visitasTrasiego.POST,
            'visitas-trasiego',
            'Actualizar Visita',
            'Crear Visita'
        );
    }

    ngOnInit() {
        this.initFormData();

        this.createReactiveForm();
        this.softInit(this.getType());
    }


    public formChanges(tag: string) {
        if (tag === 'id_finca') {
            this.model.id_parcela = null;
        }
    }


    private initFormData() {
        pool([
            build(this.fincasApi.fincasGET, this.fincas, 'nombre'),
            build(this.fincasApi.parcelasGET, this.parcelas, 'nombre', true)
        ], () => {
            this.formBuilderRef?.updateForm(this.model as unknown as Record<string, unknown>, false);
            this.dropdownsFinalized = true;
            this.dropdownLoadTrigger.next();
        });
    }

}